import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BellOff, Loader2, ArrowRight } from "lucide-react";
import { unsubscribeAlert } from "@/lib/api";

export default function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    unsubscribeAlert(token)
      .then((d) => setState({ status: "ok", ...d }))
      .catch((e) => setState({ status: "error", message: e?.response?.data?.detail || "Something went wrong" }));
  }, [token]);

  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center" data-testid="unsubscribe-page">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 text-slate-600"><BellOff className="h-8 w-8" /></div>
      {state.status === "loading" && <Loader2 className="mx-auto mt-6 h-6 w-6 animate-spin text-slate-400" />}
      {state.status === "ok" && (
        <>
          <h1 className="mt-6 font-heading text-2xl font-bold text-slate-900" data-testid="unsubscribe-ok">You're unsubscribed</h1>
          <p className="mt-2 text-slate-600">You won't receive further alerts for the {state.stream_name} ({state.province}). You can set a new alert any time from a stream score page.</p>
        </>
      )}
      {state.status === "error" && (
        <>
          <h1 className="mt-6 font-heading text-2xl font-bold text-slate-900" data-testid="unsubscribe-error">Link not valid</h1>
          <p className="mt-2 text-slate-600">{state.message}</p>
        </>
      )}
      <Link to="/draws" data-testid="unsubscribe-draws-link" className="mt-6 inline-flex items-center gap-2 rounded-md bg-[#0F172A] px-6 py-3 text-sm font-semibold text-white hover:bg-[#1E293B]">
        View draw history <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
